module.exports = __webpack_public_path__ + "static/simply-b108f39e16051997ada34459adb328b7.png";